<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link
              :to="{ path: '/CheckOutTransactions/Create' }"
              class="vs-component vs-button bg_l_green"
              v-has-permission="permission116"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("CreateCheckOutTransactions") }}
            </router-link>
            <vs-button
              @click="uploadFile()"
              class="bg_m_green float-right"
              v-if="fileUploaded"
              :disabled="disabledBtn"
              v-has-permission="permission312"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("UploadFile") }}
            </vs-button>
            <label class="custom-file-upload">
              <input
                type="file"
                id="file"
                ref="file"
                v-on:change="handleFileUpload()"
              />

              <feather-icon
                icon="PaperclipIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              {{ $t("ChooseCheckOutFile") }}
              <span v-if="uploadedFileName" class="file-name">{{
                uploadedFileName
              }}</span>
            </label>
          </div>
        </div>
        <vx-card>
          <vs-tabs vs-alignment="fixed" alignment="fixed" ref="Tabs">
            <vs-tab :label="$t('WaitingForPrintWarrantyCard')" class="mt-4">
              <waiting-for-print-warranty-card
                :tabIndex="0"
                v-if="isRender[0]"
                :numberRowsPerPage="numberRowsPerPage"
              ></waiting-for-print-warranty-card>
            </vs-tab>
            <vs-tab :label="$t('WaitingForCreateOrder')" class="mt-4">
              <waiting-for-create-order
                :tabIndex="1"
                v-if="isRender[1]"
                :numberRowsPerPage="numberRowsPerPage"
              ></waiting-for-create-order>
            </vs-tab>
            <vs-tab :label="$t('AllCheckouts')" class="mt-4">
              <all-checkouts
                :tabIndex="2"
                v-if="isRender[2]"
                :numberRowsPerPage="numberRowsPerPage"
              ></all-checkouts>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import AllCheckouts from "./AllCheckouts.vue";
import WaitingForCreateOrder from "./WaitingForCreateOrder.vue";
import WaitingForPrintWarrantyCard from "./WaitingForPrintWarrantyCard.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "warehouseManagement_CheckOutTransactions_Index",
  components: {
    AllCheckouts,
    WaitingForCreateOrder,
    WaitingForPrintWarrantyCard
  },
  data() {
    return {
      permission116: "RegisterCheckOut",
      permission312: "CheckOutWithExcelFile",
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
      referencePageInfo: {},
      isRender: [],
      numberRowsPerPage: "",
      tabIndex: 0
    };
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
    this.isRender = Array(3).fill(false);
    setTimeout(() => {
      if (this.$route.query.referencePageInfo) {
        this.referencePageInfo = this.$route.query.referencePageInfo;
        this.$refs.Tabs.value = this.referencePageInfo.tabIndex;
        this.numberRowsPerPage = this.referencePageInfo.numberRowsPerPage;
      }
      this.isRender = Array(3).fill(true);
    }, 150);
  },
  methods: {
    ...mapActions({
      importCheckOutExcel: "excel/importCheckOutExcel"
    }),
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.$refs.file.files[0].name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importCheckOutExcel(formData).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
      }, 1000);
    }
  }
};
</script>
<style lang="scss">
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
